var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPoetry = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Quill-Circle-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Quill Circle 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.85 0.15a0.49 0.49 0 0 0 -0.43 -0.15 36.35 36.35 0 0 0 -4.66 1.14 0.5 0.5 0 0 0 -0.33 0.33l-1.16 3.8a0.23 0.23 0 0 1 -0.17 0.17 0.26 0.26 0 0 1 -0.24 -0.06l-2.3 -2.31A0.54 0.54 0 0 0 14 3a23.53 23.53 0 0 0 -6.74 4.48c-2.58 2.58 -3.81 5 -3.67 7.27a5.55 5.55 0 0 0 1.18 3.07L0.29 22.3a1 1 0 0 0 0 1.41 1 1 0 0 0 1.42 0l10.83 -10.83a0.75 0.75 0 1 1 1.06 1.06l-5.8 5.79a0.26 0.26 0 0 0 -0.06 0.24 0.26 0.26 0 0 0 0.16 0.18 6.61 6.61 0 0 0 5.41 -0.85 16.44 16.44 0 0 0 3.21 -2.55C22.31 11 23.93 1 24 0.58a0.46 0.46 0 0 0 -0.15 -0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPoetry);
export default ForwardRef;